import { RawCountry } from "@/orders/entities";

export class Country {
  readonly id: string;
  readonly code: string;
  readonly description: string;

  constructor(data: RawCountry) {
    this.id = data.id;
    this.code = data.code;
    this.description = data.description;
  }
}
